module.exports = __webpack_public_path__ + "static/5-b5bcbe9f6463a81ac713c44035f28700.png";